var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateMethod = (obj, member, method) => {
  __accessCheck(obj, member, "access private method");
  return method;
};
var _createBaseDistributionUrl, createBaseDistributionUrl_fn;
import { flatten } from "../../fns/flatten.js";
function getSdExperienceUrlFromEnv(env, opt) {
  const domainPrefix = (opt == null ? void 0 : opt.cdn) === true ? "content" : "experience";
  if (env == null || env === "prod")
    return `https://${domainPrefix}.sourcesync.io`;
  if (["dev", "stg"].includes(env))
    return `https://${domainPrefix}-${env}.sourcesync.io`;
  throw new Error(`Unknown env: ${env}`);
}
function getSdApiUrlFromEnv(env) {
  if (env == null || env === "prod")
    return "https://api.sourcesync.io";
  if (["dev", "stg"].includes(env))
    return `https://api-${env}.sourcesync.io`;
  throw new Error(`Unknown env: ${env}`);
}
class ExperienceUrlBuilder {
  constructor(baseUrl) {
    __privateAdd(this, _createBaseDistributionUrl);
    __publicField(this, "baseUrl");
    this.baseUrl = baseUrl;
  }
  createDistributionUrl(data, opts) {
    const url = __privateMethod(this, _createBaseDistributionUrl, createBaseDistributionUrl_fn).call(this, data);
    const flattened = flatten(opts.settings ?? {});
    Object.entries(flattened).forEach(([key, value]) => {
      url.searchParams.set(`settings.${key}`, String(value));
    });
    return url;
  }
}
_createBaseDistributionUrl = new WeakSet();
createBaseDistributionUrl_fn = function(data) {
  if (typeof data === "string" || typeof data === "number") {
    return new URL(`${this.baseUrl}/${data}`);
  } else if ("id" in data) {
    return new URL(`${this.baseUrl}/${data.id}`);
  } else if ("organizationId" in data && "clientId" in data) {
    const url = new URL(`${this.baseUrl}/redirect`);
    url.searchParams.set("organizationId", data.organizationId.toString());
    url.searchParams.set("clientId", data.clientId);
    return url;
  }
  throw new Error("Invalid data");
};
export {
  ExperienceUrlBuilder,
  getSdApiUrlFromEnv,
  getSdExperienceUrlFromEnv
};
